var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardReader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 245,
    height: 440,
    viewBox: "0 0 245 440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M201.69 1.17A33.53 33.53 0 0 0 192.897 0H33.163c-3.279 0-6.539.483-9.673 1.43V32.4h178.2V1.17z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.69,
    height: 29.16,
    x: 49.41,
    y: 297.27,
    fill: "#FFF",
    rx: 5.09
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.69,
    height: 29.16,
    x: 93.96,
    y: 297.27,
    fill: "#FFF",
    rx: 5.09
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.69,
    height: 29.16,
    x: 139.32,
    y: 297.27,
    fill: "#FFF",
    rx: 5.09
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.69,
    height: 29.16,
    x: 49.41,
    y: 261.63,
    fill: "#FFF",
    rx: 5.09
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.69,
    height: 29.16,
    x: 93.96,
    y: 261.63,
    fill: "#FFF",
    rx: 5.09
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.69,
    height: 29.16,
    x: 139.32,
    y: 261.63,
    fill: "#FFF",
    rx: 5.09
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.69,
    height: 29.16,
    x: 49.41,
    y: 225.99,
    fill: "#FFF",
    rx: 5.09
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.69,
    height: 29.16,
    x: 93.96,
    y: 225.99,
    fill: "#FFF",
    rx: 5.09
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.69,
    height: 29.16,
    x: 139.32,
    y: 225.99,
    fill: "#FFF",
    rx: 5.09
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.69,
    height: 29.16,
    x: 49.41,
    y: 191.16,
    fill: "#FFF",
    rx: 5.09
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.69,
    height: 29.16,
    x: 93.96,
    y: 191.16,
    fill: "#FFF",
    rx: 5.09
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.69,
    height: 29.16,
    x: 139.32,
    y: 191.16,
    fill: "#FFF",
    rx: 5.09
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M233.665 47.344v.081h.04v-.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M244.618 70.753a29.5 29.5 0 0 0-10.515-22.9v1.184l-3.035 218.384-.967 70.63a30.8 30.8 0 0 1-7.434 4.783l3.519-265.282c0-6.405 0-11.757-.352-16.32l.352-26.628c.152-12.494-6.776-24.004-17.903-29.744l-.308 34H17.16l-.395-33.43C6.234 11.374-.196 22.583.004 34.648l.484 23.207a26.253 26.253 0 0 0-.352 4.738L5.46 406.357c.428 18.529 15.551 33.36 34.134 33.473h148.192c18.577-.092 33.688-14.948 34.046-33.473v-2.281c11.206-4.71 18.582-15.556 18.826-27.682l3.961-305.203v-.438zM46.675 50.485h133.192c3.13 0 6.131 1.246 8.336 3.461a11.699 11.699 0 0 1 3.41 8.34l-.837 86.906H35.942l-1.057-86.906a11.657 11.657 0 0 1 3.381-8.337 11.717 11.717 0 0 1 8.32-3.464h.089zm3.563 293.928c-6.537-.047-11.846-5.282-11.965-11.801l-2.023-156.22h154.306l-1.495 156.22c-.096 6.529-5.418 11.778-11.965 11.801H50.15h.088zm107.592 39.79v1.667c0 7.269-5.908 13.161-13.196 13.161H129.37c-7.288 0-13.196-5.892-13.196-13.161v-1.667c0-7.269 5.908-13.161 13.196-13.161h15.22c7.27.024 13.152 5.91 13.152 13.161h.088zm-46.23 0v1.667c0 7.269-5.909 13.161-13.197 13.161H83.14c-7.288 0-13.196-5.892-13.196-13.161v-1.667c0-7.269 5.908-13.161 13.196-13.161h15.22c7.27.024 13.152 5.91 13.152 13.161h.088zM45.487 166.521v-7.897h68.268v7.897H45.487zm81.156 0v-7.897h52.389v7.897h-52.389zM37.79 398.548c-7.116-.628-12.605-6.519-12.712-13.643v-1.799a12.488 12.488 0 0 1 3.99-9.23 12.557 12.557 0 0 1 9.514-3.317l15.264 1.097c7.098.673 12.543 6.577 12.624 13.688v1.667a12.442 12.442 0 0 1-3.627 8.91 12.51 12.51 0 0 1-8.91 3.68h-.66l-15.483-1.053zm144.542 28.428H44.167v-9.3h138.164v9.3zm21.73-43.212c-.108 7.124-5.597 13.015-12.713 13.644l-15.263 1.097h-.968a12.51 12.51 0 0 1-8.925-3.696 12.442 12.442 0 0 1-3.611-8.939v-1.667c.107-7.124 5.596-13.015 12.712-13.644l15.263-1.096c3.497-.27 6.947.933 9.513 3.317a12.488 12.488 0 0 1 3.992 9.23v1.754z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardReader);
export default __webpack_public_path__ + "static/media/card-reader.e7cecc6f.svg";
export { ForwardRef as ReactComponent };